import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { isLogin } from '@src/js/common/utils';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';

@Feature()
export class AddonUnofficialFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    protected getCustomDisabledState(): boolean {
        const shouldDisabledInMaster = this.shouldDisableInMaster(config.id);
        const { pptEditorState } = this.getUserPriviledgeService();
        if ((pptEditorState === PPTEditorStateType.EDITABLE && isLogin()) && !shouldDisabledInMaster) {
            return false;
        }
        return true;
    }
}
